
const nfSaidaTotalTributos = {
  calculaBaseIcms: (produto, nfSaida) => {
    if (produto?.tributosIcmsBaseCalculoValor) {
      return produto?.tributosIcmsBaseCalculoValor;
    }
    if (
      (produto?.calculaIcms && produto?.tributosIcmsCsosn === "900") ||
      nfSaida?.documentoDevolucaoFornecedor
    ) {
      if (produto?.tributosIcmsBaseCalculoPercentualReducao) {
        return (
          produto?.subtotal -
          produto?.subtotal * produto?.tributosIcmsBaseCalculoPercentualReducao
        );
      } else {
        return produto?.subtotal;
      }
    } else {
      return 0;
    }
  },
  calculaBaseIcmsSt: (produto, nfSaida) => {
    if (produto?.tributosIcmsBaseCalculoModalidadeST) {
      return produto.tributosIcmsBaseCalculoModalidadeST;
    }
    if (
      (produto?.calculaIcmsSt && produto?.tributosIcmsCsosn === "900") ||
      nfSaida?.documentoDevolucaoFornecedor
    ) {
      const subtotalComIpi =
        produto?.subtotal +
        (produto?.subtotal * (produto?.tributosIpiAliquota || 0)) / 100;
      const total = parseFloat(
        (subtotalComIpi + (subtotalComIpi * produto.aliquotaMva) / 100).toFixed(
          2
        )
      );
      if (produto?.impostoIcmsStReducao) {
        return total - (total * produto?.impostoIcmsStReducao) / 100;
      } else {
        return total;
      }
    } else {
      return 0;
    }
  },
  calculaBaseIpi: (produto, nfSaida) => {
    if (produto?.tributosIpiBaseCalculoValor) {
      return produto?.tributosIpiBaseCalculoValor;
    }
    if (
      (produto?.calculaIcms && produto?.tributosIcmsCsosn === "900") ||
      nfSaida?.documentoDevolucaoFornecedor
    ) {
      return produto?.subtotal;
    } else {
      return "0";
    }
  },
  calculaValorIcms: (produto, nfSaida) => {
    if (produto?.tributosIcmsValor && nfSaida?.id) {
      return produto?.tributosIcmsValor;
    }
    if (
      (produto?.calculaIcms && produto?.tributosIcmsCsosn === "900") ||
      nfSaida?.documentoDevolucaoFornecedor
    ) {
      if (produto?.tributosIcmsBaseCalculoPercentualReducao) {
        return (
          ((produto?.subtotal -
            (produto?.subtotal *
              produto?.tributosIcmsBaseCalculoPercentualReducao) /
              100) *
            (produto?.tributosIcmsAliquota || 0)) /
          100
        );
      } else {
        return (produto?.subtotal * (produto?.tributosIcmsAliquota || 0)) / 100;
      }
    } else {
      return 0;
    }
  },
  calculaValorIcmsSt: (produto, nfSaida) => {
    if (produto?.impostoIcmsSt && nfSaida.id) {
      return produto.impostoIcmsSt;
    }
    if (
      (produto?.calculaIcmsSt && produto?.tributosIcmsCsosn === "900") ||
      nfSaida?.documentoDevolucaoFornecedor
    ) {
      const subtotalComIpi =
        produto?.subtotal +
        (produto?.subtotal * (produto?.tributosIpiAliquota || 0)) / 100;
      const total = parseFloat(
        (subtotalComIpi + (subtotalComIpi * produto.aliquotaMva) / 100).toFixed(
          2
        )
      );
      if (produto?.impostoIcmsStReducao) {
        return (
          total -
          ((total * produto.impostoIcmsStReducao) / 100) *
            ((produto?.impostoIcmsStAliquota || 0) / 100) -
          nfSaidaTotalTributos.calculaValorIcms(produto, nfSaida)
        );
      } else {
        return (
          (total * (produto?.impostoIcmsStAliquota || 0)) / 100 -
          nfSaidaTotalTributos.calculaValorIcms(produto, nfSaida)
        );
      }
    } else {
      return 0;
    }
  },
  calculaValorIpi: (produto, nfSaida) => {
    if (produto?.tributosIpiValor && nfSaida.id) {
      return produto?.tributosIpiValor;
    }
    if (
      (produto?.calculaIpi && produto?.tributosIpiCsosn === "900") ||
      nfSaida?.documentoDevolucaoFornecedor
    ) {
      return (produto?.subtotal * (produto?.tributosIpiAliquota || 0)) / 100;
    } else {
      return "0";
    }
  },
  totalBaseIcms: (id, nfSaidaItens, nfSaida) => {
    if (id) {
      return nfSaidaItens.reduce((acumulador, itemAtual) => {
        return acumulador + itemAtual.tributosIcmsBaseCalculoValor;
      }, 0);
    } else if (nfSaida?.documentoDevolucaoFornecedor) {
      return nfSaidaItens.reduce((acumulador, itemAtual) => {
        const baseCalculo = itemAtual.tributosIcmsBaseCalculoValor ?? 0;
        return acumulador + baseCalculo;
      }, 0);
    } else {
      return nfSaidaItens.reduce((acumulador, itemAtual) => {
        const subTotal = itemAtual?.valor * (itemAtual?.quantidade ?? 1);
        if (itemAtual?.tributosIcmsCsosn) {
          if (
            itemAtual.tributosIcmsCsosn.includes("900") &&
            itemAtual?.calculaIcms
          ) {
            const baseCalculo =
              subTotal -
              (subTotal * itemAtual.tributosIcmsBaseCalculoPercentualReducao ||
                0);
            return acumulador + parseFloat(baseCalculo);
          }
        }
        return acumulador;
      }, 0);
    }
  },
  totalValorIcms: (id, nfSaidaItens, nfSaida) => {
    if (id) {
      return nfSaidaItens.reduce((acumulador, itemAtual) => {
        return acumulador + itemAtual.tributosIcmsValor;
      }, 0);
    } else if (nfSaida?.documentoDevolucaoFornecedor) {
      return nfSaidaItens.reduce((acumulador, itemAtual) => {
        const baseCalculo =
          itemAtual.tributosIcmsBaseCalculoValor ?? 0 -
          ((itemAtual.tributosIcmsBaseCalculoValor ?? 0) * itemAtual?.tributosIcmsBaseCalculoPercentualReducao || 0);
        const valorIcms =
          baseCalculo * ((itemAtual?.tributosIcmsAliquota ?? 0) / 100);
        return acumulador + parseFloat(valorIcms);
      }, 0);
    } else {
      return nfSaidaItens.reduce((acumulador, itemAtual) => {
        const subTotal = itemAtual?.valor * (itemAtual?.quantidade ?? 1);
        if (itemAtual?.tributosIcmsCsosn) {
          if (
            itemAtual.tributosIcmsCsosn.includes("900") &&
            itemAtual?.calculaIcms
          ) {
            const baseCalculo =
              subTotal -
              (subTotal * itemAtual.tributosIcmsBaseCalculoPercentualReducao ||
                0);
            const valorIcms =
              baseCalculo * ((itemAtual?.tributosIcmsAliquota ?? 0) / 100);
            return acumulador + parseFloat(valorIcms);
          }
        }
        return acumulador;
      }, 0);
    }
  },
  totalBaseIcmsSt: (id, nfSaidaItens, nfSaida) => {
    if (id) {
      return nfSaidaItens.reduce((acumulador, itemAtual) => {
        return acumulador + itemAtual.impostoIcmsStBase;
      }, 0);
    } else if (nfSaida?.documentoDevolucaoFornecedor) {
      return nfSaidaItens.reduce((acumulador, itemAtual) => {
        if (itemAtual.impostoIcmsStAliquota) {
          return (
            acumulador +
            nfSaidaTotalTributos.calculaBaseIcmsSt(itemAtual, nfSaida)
          );
        } else {
          return 0;
        }
      }, 0);
    } else {
      return nfSaidaItens.reduce((acumulador, itemAtual) => {
        const subTotal = itemAtual?.valor * (itemAtual?.quantidade ?? 1);
        if (itemAtual?.tributosIcmsCsosn) {
          if (
            itemAtual.tributosIcmsCsosn.includes("900") &&
            itemAtual?.calculaIcmsSt
          ) {
            const baseCalculo =
              subTotal - (subTotal * itemAtual.impostoIcmsStAliquota || 0);
            return acumulador + parseFloat(baseCalculo);
          }
        }
        return acumulador;
      }, 0);
    }
  },
  totalValorIcmsSt: (id, nfSaidaItens, nfSaida) => {
    if (id) {
      return nfSaidaItens.reduce((acumulador, itemAtual) => {
        return acumulador + itemAtual.impostoIcmsSt;
      }, 0);
    } else if (nfSaida?.documentoDevolucaoFornecedor) {
      return nfSaidaItens.reduce((acumulador, itemAtual) => {
        if (itemAtual.impostoIcmsStAliquota) {
          return (
            acumulador +
            nfSaidaTotalTributos.calculaValorIcmsSt(itemAtual, nfSaida)
          );
        } else {
          return 0;
        }
      }, 0);
    } else {
      return nfSaidaItens.reduce((acumulador, itemAtual) => {
        const subTotal = itemAtual?.valor * (itemAtual?.quantidade ?? 1);
        if (itemAtual?.tributosIcmsCsosn) {
          if (
            itemAtual.tributosIcmsCsosn.includes("900") &&
            itemAtual?.calculaIcmsSt
          ) {
            const baseCalculo =
              subTotal - (subTotal * itemAtual.impostoIcmsStReducao || 0);
            const valorIcms =
              baseCalculo * ((itemAtual?.impostoIcmsStAliquota ?? 0) / 100);
            return acumulador + parseFloat(valorIcms);
          }
        }
        return acumulador;
      }, 0);
    }
  },
  totalValorIpi: (id, nfSaidaItens, devolucao) => {
    if (id) {
      return nfSaidaItens.reduce((acumulador, itemAtual) => {
        return acumulador + itemAtual.tributosIpiValor;
      }, 0);
    } else if (devolucao) {
      return nfSaidaItens.reduce((acumulador, itemAtual) => {
        const baseCalculo = itemAtual.tributosIpiBaseCalculoValor ?? 0;
        const valorIpi = baseCalculo * (itemAtual?.tributosIpiAliquota / 100 ?? 0);
        return acumulador + parseFloat(valorIpi);
      }, 0);
    } else {
      return nfSaidaItens.reduce((acumulador, itemAtual) => {
        const subTotal = itemAtual?.valor * (itemAtual?.quantidade ?? 1)
          + (itemAtual.frete ?? 0) + (itemAtual.despesas ?? 0) - (itemAtual.desconto ?? 0);
        const valorIpi = subTotal * (itemAtual?.tributosIpiAliquota / 100 ?? 0);
        return acumulador + parseFloat(valorIpi);
      }, 0);
    }
  },
  totalValorIbsUf: (id, nfSaidaItens, devolucao) => {
    if (id) {
      return nfSaidaItens.reduce((acumulador, itemAtual) => {
        return acumulador + itemAtual.tributosIbsUfValor;
      }, 0);
    } else if (devolucao) {
      return nfSaidaItens.reduce((acumulador, itemAtual) => {
        const baseCalculo = itemAtual.tributosIbsBaseCalculo ?? 0;
        return acumulador + baseCalculo * (itemAtual.tributosIbsAliquotaUf ?? 0) / 100;
      }, 0);
    } else {
      return nfSaidaItens.reduce((acumulador, itemAtual) => {
        const subTotal = itemAtual?.valor * (itemAtual?.quantidade ?? 1) 
          + (itemAtual.frete ?? 0) + (itemAtual.despesas ?? 0) - (itemAtual.desconto ?? 0);
        const totalImpostos = (itemAtual.tributosIcmsValor ?? 0) + (itemAtual.tributosIpiValor ?? 0) 
          + (itemAtual.tributosPisValor ?? 0) + (itemAtual.tributosCofinsValor ?? 0);
        const baseCalculo = subTotal - totalImpostos;

        return acumulador + baseCalculo * (itemAtual.tributosIbsAliquotaUf ?? 0) / 100;
      }, 0);
    }
  },
  totalValorIbsMun: (id, nfSaidaItens, devolucao) => {
    if (id) {
      return nfSaidaItens.reduce((acumulador, itemAtual) => {
        return acumulador + itemAtual.tributosIbsMunValor;
      }, 0);
    } else if (devolucao) {
      return nfSaidaItens.reduce((acumulador, itemAtual) => {
        const baseCalculo = itemAtual.tributosIbsBaseCalculo ?? 0;
        return acumulador + baseCalculo * (itemAtual.tributosIbsAliquotaMun ?? 0) / 100;
      }, 0);
    } else {
      return nfSaidaItens.reduce((acumulador, itemAtual) => {
        const subTotal = itemAtual?.valor * (itemAtual?.quantidade ?? 1) 
          + (itemAtual.frete ?? 0) + (itemAtual.despesas ?? 0) - (itemAtual.desconto ?? 0);
        const totalImpostos = (itemAtual.tributosIcmsValor ?? 0) + (itemAtual.tributosIpiValor ?? 0)
          + (itemAtual.tributosPisValor ?? 0) + (itemAtual.tributosCofinsValor ?? 0);
        const baseCalculo = subTotal - totalImpostos;

        return acumulador + baseCalculo * (itemAtual.tributosIbsAliquotaMun ?? 0) / 100;
      }, 0);
    }
  },
  totalValorCbs: (id, nfSaidaItens, devolucao) => {
    if (id) {
      return nfSaidaItens.reduce((acumulador, itemAtual) => {
        return acumulador + itemAtual.tributosCbsValor;
      }, 0);
    } else if (devolucao) {
      return nfSaidaItens.reduce((acumulador, itemAtual) => {
        const baseCalculo = itemAtual.tributosIbsBaseCalculo ?? 0;
        return acumulador + baseCalculo * (itemAtual.tributosIbsAliquotaCbs ?? 0) / 100;
      }, 0);
    } else {
      return nfSaidaItens.reduce((acumulador, itemAtual) => {
        const subTotal = itemAtual?.valor * (itemAtual?.quantidade ?? 1) 
          + (itemAtual.frete ?? 0) + (itemAtual.despesas ?? 0) - (itemAtual.desconto ?? 0);
        const totalImpostos = (itemAtual.tributosIcmsValor ?? 0) + (itemAtual.tributosIpiValor ?? 0) 
          + (itemAtual.tributosPisValor ?? 0) + (itemAtual.tributosCofinsValor ?? 0);
        const baseCalculo = subTotal - totalImpostos;

        return acumulador + baseCalculo * (itemAtual.tributosIbsAliquotaCbs ?? 0) / 100;
      }, 0);
    }
  },
};

export default nfSaidaTotalTributos;
